import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChart6: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconChart6"><Path d="M9.17 20.5V14.5H3.5V20.5H9.17ZM9.17 20.5L9.17001 9H14.84V20.5M9.17 20.5H14.84M14.84 20.5H20.51V3.5H14.84L14.84 20.5ZM1.5 20.5H22.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconChart6;
